module.exports = __webpack_public_path__ + "static/media/bg3.34166d04.jpg";